"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRegistryProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("./context");
const InputRegistryProvider = props => {
    const { children, registeredInputs, setRegisteredInputs } = props;
    const registerInput = (name, isAsync = true) => {
        setRegisteredInputs(inputs => [...inputs, { name, isAsync }]);
    };
    const unregisterInput = (name) => {
        setRegisteredInputs(inputs => inputs.filter(input => input.name !== name));
    };
    return ((0, jsx_runtime_1.jsx)(context_1.InputRegistryContext.Provider, { value: { registeredInputs, registerInput, unregisterInput }, children: children }));
};
exports.InputRegistryProvider = InputRegistryProvider;
//# sourceMappingURL=provider.js.map